import { atom } from 'jotai';
import { $UserRelatedUser } from 'shared/atoms';
import { $CurrentUserLinkName } from '@user/shared/current-user';

export const $CurrentUserRelatedUser = atom((get) => {
  const currentUserLinkName = get($CurrentUserLinkName);
  return get($UserRelatedUser(currentUserLinkName));
});
